import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const bookingServices = createApi({
  reducerPath: "bookTicket",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    bookTicket: builder.mutation({
      query: (data) => {
        return {
          url: "/api/ticket_book_v3.php",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["bookTicketOperation"],
    }),
  }),
  tagTypes: ["bookTicketOperation"],
});

export const { useBookTicketMutation } = bookingServices;

export default bookingServices;
